"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var styled_components_1 = __importStar(require("styled-components"));
var Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: flex;\n\tflex-direction: column;\n\tflex-wrap: nowrap;\n\n\tmax-height: 100%;\n\t", ";\n"], ["\n\tdisplay: flex;\n\tflex-direction: column;\n\tflex-wrap: nowrap;\n\n\tmax-height: 100%;\n\t", ";\n"])), function (props) { return props.theme.verticalList.container; });
var Button = styled_components_1.default.button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tflex-grow: 0;\n\tflex-shrink: 0;\n\n\tmax-height: 64px;\n\n\t", ";\n\t@media ", "{\n\t\tdisplay: none;\n\t}\n"], ["\n\tflex-grow: 0;\n\tflex-shrink: 0;\n\n\tmax-height: 64px;\n\n\t", ";\n\t@media ", "{\n\t\tdisplay: none;\n\t}\n"])), function (props) { return props.theme.verticalList.scrollButton; }, function (props) { return props.theme.breakpoints.S; });
var UpButton = styled_components_1.default(Button)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\t", ";\n"], ["\n\t", ";\n"])), function (props) { return props.theme.verticalList.scrollUpButton; });
var DownButton = styled_components_1.default(Button)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\t", ";\n"], ["\n\t", ";\n"])), function (props) { return props.theme.verticalList.scrollDownButton; });
var Viewport = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tflex-grow: 1;\n\tflex-shrink: 1;\n\twidth: 100%;\n\n\toverscroll-behavior: contain;\n\t\n\toverflow-x: hidden;\n\toverflow-y: auto;\n\t-ms-overflow-style: none;\n\t\n\tscrollbar-width: 0px;\n\tscrollbar-width: none;\n\n\t&::-webkit-scrollbar {\n\t\twidth: 0%;\n\t}\n\t\n\tscroll-snap-destination: center;\n\tscroll-snap-type: y mandatory;\n\t/*scroll-snap-type: mandatory; Seems to break scrolling on IE11*/\n\t\n\t@supports (-webkit-overflow-scrolling: touch){\n\t\t-webkit-overflow-scrolling: touch;\n\t}\n\n\t", ";\n\n\tmargin: 0 auto;\n"], ["\n\tflex-grow: 1;\n\tflex-shrink: 1;\n\twidth: 100%;\n\n\toverscroll-behavior: contain;\n\t\n\toverflow-x: hidden;\n\toverflow-y: auto;\n\t-ms-overflow-style: none;\n\t\n\tscrollbar-width: 0px;\n\tscrollbar-width: none;\n\n\t&::-webkit-scrollbar {\n\t\twidth: 0%;\n\t}\n\t\n\tscroll-snap-destination: center;\n\tscroll-snap-type: y mandatory;\n\t/*scroll-snap-type: mandatory; Seems to break scrolling on IE11*/\n\t\n\t@supports (-webkit-overflow-scrolling: touch){\n\t\t-webkit-overflow-scrolling: touch;\n\t}\n\n\t", ";\n\n\tmargin: 0 auto;\n"])), function (props) { return props.theme.verticalList.viewport; });
var Content = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\tposition: relative;\n\tdisplay: flex;\n\tflex-flow: column nowrap;\n\tjustify-content: right;\n\talign-items: stretch;\n\t", ";\n\n"], ["\n\tposition: relative;\n\tdisplay: flex;\n\tflex-flow: column nowrap;\n\tjustify-content: right;\n\talign-items: stretch;\n\t", ";\n\n"])), function (props) { return props.theme.verticalList.content; });
var Item = styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\tscroll-snap-align: center;\n"], ["\n\tscroll-snap-align: center;\n"])));
var VerticalList = /** @class */ (function (_super) {
    __extends(VerticalList, _super);
    function VerticalList(props) {
        var _this = _super.call(this, props) || this;
        _this.onResize = function () {
            //Compute visible/hidden state for scroll buttons
            if (_this.container.current && _this.content.current) {
                _this.setState({ showScrollButtons: _this.container.current.clientHeight < _this.content.current.clientHeight });
            }
        };
        _this.onScroll = function () {
            //Compute enabled/disabled state for scroll buttons
            var vp = _this.viewport.current;
            var c = _this.content.current;
            if (vp && c) {
                _this.setState({
                    disableScrollUp: vp.scrollTop <= 20,
                    disableScrollDown: (vp.scrollTop + vp.clientHeight) >= (c.clientHeight - 20)
                });
            }
        };
        _this.getFocusItem = function (target) {
            if (_this.content.current && target) {
                var item = _this.content.current.firstElementChild;
                while (item !== null) {
                    if (item.contains(target)) {
                        return item;
                    }
                    item = item.nextElementSibling;
                }
            }
            return undefined;
        };
        _this.onFocus = function (ev) {
            /*Determine which child item was clicked*/
            if (_this.content.current) {
                var focusItem = _this.getFocusItem(ev.target);
                if (focusItem) {
                    _this.ensureVisible(focusItem);
                }
            }
        };
        _this.ensureVisible = function (item) {
            var vp = _this.viewport.current;
            if (vp) {
                if (item.offsetTop < vp.scrollTop) {
                    item.scrollIntoView({ behavior: "smooth", block: "start" });
                }
                else if (item.offsetTop + item.clientHeight > vp.scrollTop + vp.clientHeight) {
                    item.scrollIntoView({ behavior: "smooth", block: "end" });
                }
            }
        };
        _this.scrollUp = function () {
            var vp = _this.viewport.current;
            if (vp) {
                vp.scrollTop = Math.max(vp.scrollTop - vp.clientHeight, 0);
            }
        };
        _this.scrollDown = function () {
            var vp = _this.viewport.current;
            var c = _this.content.current;
            if (vp && c) {
                vp.scrollTop = Math.min(vp.scrollTop + vp.clientHeight, c.clientHeight - vp.clientHeight);
            }
        };
        _this.onKeyPress = function (ev) {
            console.log(window.document.activeElement);
            var content = _this.content.current;
            if (!content) {
                console.log("content undefined");
                return;
            }
            var current = undefined;
            content.childNodes.forEach(function (child, index) {
                if (child.contains(window.document.activeElement)) {
                    current = index;
                }
            });
            if (current === undefined) {
                console.log("current undefined");
                return;
            }
            if (ev.key === "ArrowUp") {
                if (current > 0) {
                    var button = (content.children[current - 1]).getElementsByTagName("button")[0];
                    if (button) {
                        button.focus();
                    }
                }
            }
            else if (ev.key === "ArrowDown") {
                if (current < content.childElementCount - 1) {
                    var button = (content.children[current + 1]).getElementsByTagName("button")[0];
                    if (button) {
                        button.focus();
                    }
                }
            }
        };
        _this.container = react_1.default.createRef();
        _this.viewport = react_1.default.createRef();
        _this.content = react_1.default.createRef();
        _this.state = {
            showScrollButtons: false,
            disableScrollUp: false,
            disableScrollDown: false
        };
        return _this;
    }
    VerticalList.prototype.componentDidMount = function () {
        var _this = this;
        window.addEventListener("resize", this.onResize); //If ResizeObservers become standard, use them instead
        this.onResize();
        this.onScroll();
        requestAnimationFrame(function () {
            if (_this.content.current && _this.props.initialFocusIndex !== undefined) {
                var focusItem = _this.content.current.children[_this.props.initialFocusIndex];
                if (focusItem) {
                    _this.ensureVisible(focusItem);
                    var focusElement = focusItem.querySelector("button, [href], input, select, textarea, [tabindex]:not([tabindex='-1'])");
                    if (focusElement) {
                        focusElement.focus();
                    }
                }
            }
        });
    };
    VerticalList.prototype.componentWillUnmount = function () {
        window.removeEventListener("resize", this.onResize);
    };
    VerticalList.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.children !== undefined) {
            var children = react_1.default.Children.toArray(this.props.children);
            var prevChildren = react_1.default.Children.toArray(prevProps.children);
            if (prevChildren.length !== children.length) {
                this.onResize();
                this.onScroll();
            }
        }
    };
    VerticalList.prototype.render = function () {
        var children = react_1.default.Children.toArray(this.props.children);
        if (children.length === 0) {
            return null;
        }
        return (react_1.default.createElement(Container, { ref: this.container, className: this.props.className },
            this.state.showScrollButtons &&
                react_1.default.createElement(UpButton, { "data-automationid": "vert_scrollup", onClick: this.scrollUp, disabled: this.state.disableScrollUp, "aria-label": "" }, this.props.theme.svgs.BTN_Arrow_Light),
            react_1.default.createElement(Viewport, { ref: this.viewport, onScroll: this.onScroll, showGradientTop: !this.state.disableScrollUp, showGradientBottom: !this.state.disableScrollDown },
                react_1.default.createElement(Content, { ref: this.content, onKeyDown: this.onKeyPress, onFocusCapture: this.onFocus }, children.map(function (child, index) {
                    return (react_1.default.createElement(Item, { key: index }, child));
                }))),
            this.state.showScrollButtons &&
                react_1.default.createElement(DownButton, { "data-automationid": "vert_scrolldown", onClick: this.scrollDown, disabled: this.state.disableScrollDown, "aria-label": "" }, this.props.theme.svgs.BTN_Arrow_Light)));
    };
    VerticalList.propTypes = {
        /** Maximum number of items to display at a time */
        prevLabel: prop_types_1.default.string,
        nextLabel: prop_types_1.default.string,
        children: prop_types_1.default.node
    };
    return VerticalList;
}(react_1.Component));
exports.default = styled_components_1.withTheme(VerticalList);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
//# sourceMappingURL=VerticalList.js.map